module.exports = __webpack_public_path__ + "media/components/Header/logo-text-94b4c8eba85fe5ff2f490453ac1756ff.png";